import { ResultAccessMap } from './resultAccess.types';

export const RESULT_ACCESS: ResultAccessMap = {
  order: {
    open: { action: 'read', subject: 'order-details' },
  },
  product: {
    open: { action: 'read', subject: 'catalogs' },
    itemAction: { action: 'create', subject: 'order-items' },
  },
  customer: {
    open: { action: 'menu', subject: 'customers' },
  },
  catalog: {
    open: { action: 'menu', subject: 'catalogs' },
  },
  invoice: {
    open: { action: 'menu', subject: 'invoices' },
  },
  accountReceivable: {
    open: { action: 'menu', subject: 'accounts-receivable' },
  },
};
